export function useIsViewedVin(): boolean {
  return false; // stand-in until logic exists to determine if VIN is viewed.
}
